const DEFAULT_STEP_VIDEO = {
  shouldUseContentPlayer: true,
};

export const getStepVideoConfig = (step) => {
  if (!step) return null;

  const stepMetaData = step.stepMetaData || {};
  const metaVideoId = stepMetaData?.videoId || stepMetaData?.brightcoveVideoId;

  if (!metaVideoId) return null;

  return {
    videoId: metaVideoId,
    videoName: stepMetaData?.videoName || null,
    videoType: stepMetaData?.videoType || null,
    shouldUseContentPlayer:
      stepMetaData?.shouldUseContentPlayer
      ?? DEFAULT_STEP_VIDEO.shouldUseContentPlayer,
  };
};
